export const stringToFilename = (text: string) =>
  text.replace(/[/\\?%*:|"<>.,;=\s]/g, '_');
